import { TextField } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import ActionDialog from "@saleor/components/ActionDialog";
import React, { useEffect, useState } from "react";

import constants from "../constants";
import { getError, hasNoError } from "../validators";

const useStyles = makeStyles(
  () => ({
    fieldsSpan: {
      display: "flex",
      flexDirection: "column"
    },
    labelStyles: {
      fontSize: "17px",
      fontWeight: 400
    }
  }),
  { name: "HomeLocationActionDialog" }
);

interface ActionDialogProps {
  data: any;
  open: boolean;
  mode: string;
  onClose: () => void;
  onConfirm: (data) => void;
}

function HomeLocationActionDialog(props: ActionDialogProps) {
  const classes = useStyles(props);
  const { data: formData, open, mode, onClose, onConfirm } = props;
  const { HOME_LOCATION_SPIELS } = constants;
  const [errors, setErrors] = useState({
    latitude: {
      isError: false,
      message: ""
    },
    longitude: {
      isError: false,
      message: ""
    },
    name: {
      isError: false,
      message: ""
    },
    remarks: {
      isError: false,
      message: ""
    }
  });

  const [values, setValues] = useState({
    id: formData?.id || "",
    latitude: formData?.latitude || "",
    longitude: formData?.longitude || "",
    name: formData?.name || "",
    remarks: formData?.remarks || ""
  });

  function handleChange(event) {
    const value = event.target.value;
    setValues({
      ...values,
      [event.target.name]: value,
      id: formData?.id
    });
  }

  function handleSubmit() {
    handleValidation();

    if (hasNoError(errors)) {
      if (!Object.values(values).includes("")) {
        onConfirm(values);
        onClose();
        resetForm();
      }
    }
  }

  function handleValidation() {
    getError(values);
    setErrors({
      latitude: {
        isError: getError(values).latitude.isError,
        message: getError(values).latitude.message
      },
      longitude: {
        isError: getError(values).longitude.isError,
        message: getError(values).longitude.message
      },
      name: {
        isError: getError(values).name.isError,
        message: getError(values).name.message
      },
      remarks: {
        isError: getError(values).remarks.isError,
        message: getError(values).remarks.message
      }
    });
  }

  function resetForm() {
    setValues({
      id: "",
      latitude: "",
      longitude: "",
      name: "",
      remarks: ""
    });
  }

  useEffect(() => {
    if (mode === "Edit") {
      setValues({
        id: formData?.id,
        latitude: formData?.latitude,
        longitude: formData?.longitude,
        name: formData?.name,
        remarks: formData?.remarks
      });
    }

    if (mode === "Add") {
      resetForm();
    }
  }, [formData, mode]);

  return (
    <ActionDialog
      open={open}
      onClose={onClose}
      confirmButtonState="success"
      onConfirm={handleSubmit}
      variant="default"
      title={`${mode} Home Location`}
      confirmButtonLabel={mode === "Edit" ? "UPDATE" : "SUBMIT"}
    >
      <form onSubmit={handleSubmit}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <span className={classes.fieldsSpan}>
              <label className={classes.labelStyles}>Home Location Name</label>
              <TextField
                required
                name="name"
                id="input-name"
                defaultValue={values.name}
                fullWidth
                onChange={handleChange}
                error={errors.name.isError}
                helperText={errors.name.message}
              />
            </span>
          </Grid>

          <Grid item xs={12} sm>
            <span className={classes.fieldsSpan}>
              <label className={classes.labelStyles}>
                {HOME_LOCATION_SPIELS.HOME_LOCATION_FIELDS.LATITUDE}
              </label>
              <TextField
                required
                name="latitude"
                id="input-latitude"
                defaultValue={values.latitude}
                fullWidth
                onChange={handleChange}
                error={errors.latitude.isError}
                helperText={errors.latitude.message}
                type="number"
              />
            </span>
          </Grid>
          <Grid item xs={12} sm>
            <span className={classes.fieldsSpan}>
              <label className={classes.labelStyles}>
                {HOME_LOCATION_SPIELS.HOME_LOCATION_FIELDS.LONGITUDE}
              </label>
              <TextField
                required
                name="longitude"
                id="input-longitude"
                defaultValue={values.longitude}
                fullWidth
                onChange={handleChange}
                error={errors.longitude.isError}
                helperText={errors.longitude.message}
                type="number"
              />
            </span>
          </Grid>
          <Grid item xs={12}>
            <span className={classes.fieldsSpan}>
              <label className={classes.labelStyles}>
                {HOME_LOCATION_SPIELS.HOME_LOCATION_FIELDS.REMARKS}
              </label>
              <TextField
                required
                name="remarks"
                multiline
                id="input-remarks"
                defaultValue={values.remarks}
                onChange={handleChange}
                error={errors.remarks.isError}
                helperText={errors.remarks.message}
              />
            </span>
          </Grid>
        </Grid>
      </form>
    </ActionDialog>
  );
}

export default HomeLocationActionDialog;
